import { ScoreState } from "./scoreSlice";

export type ProductScore = {
  totalImprovement: number;
  titleImprovement: number;
  titleImprovements: string[];
  descriptionImprovement: number;
  descriptionImprovements: string[];
  categoryImprovement: number;
  categoryFullNameImprovement: number;
  productTypeImprovement: number;
  tagsImprovement: number;
  seoTitleImprovement: number;
  seoTitleImprovements: string[];
  seoDescriptionImprovement: number;
  seoDescriptionImprovements: string[];
  imagesAltTextImprovement: number;
  imagesAltTextImprovements: string[];
  contentScore: number;
  issues: string[];
};

export const getProductScore = (
  state: ScoreState,
  productId: string,
  enrichmentJobId: string
): ProductScore => {
  const initial: ProductScore = {
    totalImprovement: 0,
    titleImprovement: 0,
    titleImprovements: [],
    descriptionImprovement: 0,
    descriptionImprovements: [],
    categoryImprovement: 0,
    categoryFullNameImprovement: 0,
    productTypeImprovement: 0,
    tagsImprovement: 0,
    seoTitleImprovement: 0,
    seoTitleImprovements: [],
    seoDescriptionImprovement: 0,
    seoDescriptionImprovements: [],
    imagesAltTextImprovement: 0,
    imagesAltTextImprovements: [],
    contentScore: 0,
    issues: []
  };

  const enrichment = state.enrichments[enrichmentJobId];
  if (!enrichment) {
    return initial;
  }
  const product = enrichment.products.find((p) => p.product_id === productId);
  if (!product) {
    return initial;
  }



const imageImprx1ovement = product.old_total_images_count_score === 0 
  ? 100 // 100% improvement
  : (product.total_images_count_score / (product.old_total_images_count_score ?? 1) - 1) * 100;

const imageAltTextImprovement = product.old_total_alt_text_score === 0
  ? 100
  : (product.total_alt_text_score! / (product.old_total_alt_text_score ?? 1) - 1) * 100;

const seoDescriptionImprovement = product.old_total_seo_description_score === 0
  ? 100
  : (product.total_seo_description_score / (product.old_total_seo_description_score ?? 1) - 1) * 100;

const seoTitleImprovement = product.old_total_seo_title_score === 0
  ? 100
  : (product.total_seo_title_score! / (product.old_total_seo_title_score ?? 1) - 1) * 100;

const titleImprovement = product.old_total_title_score === 0
  ? 100
  : (product.total_title_score / (product.old_total_title_score ?? 1) - 1) * 100;

const descriptionImprovement = product.old_total_desc_html_score === 0
  ? 100
  : (product.total_desc_html_score / (product.old_total_desc_html_score ?? 1) - 1) * 100;

  const tagsImprovement = product.old_total_tags_score === 0
  ? 100
  : (product.total_tags_score / (product.old_total_tags_score ?? 1) - 1) * 100;


    const contentScore = Math.round(
      (
        product.total_title_score + 
        product.total_desc_html_score + 
        product.total_images_count_score + // Convert image count to percentage scale
        product.total_seo_description_score + 
        (product.total_category_placement_score ?? 0) + 
        (product.total_alt_text_score ?? 0) + 
        product.total_tags_score + 
        (product.total_seo_title_score?? 0)
      ) / 8
    );

    const oldScore = Math.round(
      (
        (product.old_total_title_score ?? 0) + 
        (product.old_total_desc_html_score ?? 0) + 
        (product.old_total_images_count_score ?? 0) +  // Convert image count to percentage scale
        (product.old_total_seo_description_score ?? 0) + 
       (product.old_total_category_placement_score ?? 0) + 
        (product.old_total_alt_text_score?? 0)  +
        (product.old_total_tags_score ?? 0) +
        (product.old_total_seo_title_score ?? 0)
      ) / 8
    );
  
    const totalImprovement = oldScore === 0
    ? 100
    : (contentScore / (oldScore ?? 1) - 1) * 100;
    
  let issues : string[] = []
  if(product.total_title_score < 50) {
    issues.push('Title')
  }
  if(product.total_desc_html_score < 50) {
    issues.push('Description')
  }
  if(product.total_images_count_score < 50) {
    issues.push('Image')
  }

  return {
    totalImprovement: totalImprovement,
    titleImprovement: Math.round(titleImprovement),
    titleImprovements: [
      "SEO optimized",
      "Clear value proposition",
      "Better readability",
    ],
    descriptionImprovement: Math.round(descriptionImprovement),
    descriptionImprovements: [
      "Feature highlights",
      "Engaging tone",
      "Benefit-focused",
    ],
    categoryImprovement: Math.round(initial.categoryImprovement),
    tagsImprovement: Math.round(tagsImprovement),
    categoryFullNameImprovement: Math.round(initial.categoryFullNameImprovement),
    productTypeImprovement: Math.round(initial.productTypeImprovement),
    seoDescriptionImprovement: Math.round(seoDescriptionImprovement),
    seoTitleImprovement: Math.round(seoTitleImprovement),
    seoTitleImprovements: [

    ],
    seoDescriptionImprovements: [
      'SEO optimized',
      'Clear messaging',
      'Improved keywords'
    ],
    imagesAltTextImprovement: Math.round(imageAltTextImprovement),
    imagesAltTextImprovements: [
      'Better accessibility',
      'SEO optimized',
      'Descriptive text'
    ],
    contentScore: Math.round(contentScore),
    issues
  };
};
